export var MuiLink = {
  styleOverrides: {
    root: {
      fontWeight: 600,
      cursor: 'pointer'
    }
  }
};
//# sourceMappingURL=MuiLink.js.map